import { styled } from '@clickcease/cc-client-components-lib'

export const Wrapper = styled('div', {
  color: '$black',
  width: '100%',
})

export const Title = styled('h2', {
  maxWidth: '788px',
  fontSize: '$h2',
  fontWeight: '$sb',
  margin: '0 auto $12',
  textAlign: 'center',
})

export const BoxesWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: '$12',
})

export const Box = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '150px',
  background: '$white',
  gap: '$6',
  padding: '$12 28px',
  borderRadius: '$medium',
})

export const BoxTitle = styled('div', {
  fontSize: '$h5',
  fontWeight: '$sb',
  whiteSpace: 'pre-line',
})

export const BoxDescription = styled('div', {
  fontSize: '$lg',
  fontWeight: '$l',
})

export const Image = styled('img', {
  display: 'block',
  height: '58px',
  margin: '-$6 auto $8',
})
